"use strict";
import {on, addClass, removeClass, findIn, findAllIn, closest, trigger} from '@elements/dom-utils';
import {onFind} from "@elements/init-modules-in-scope";

export function init () {
    onFind('.js-interactive-svg', function (element) {
        let container = closest('.js-interactive-svg-container', element);
        let items = findAllIn('.js-interactive-svg__item', element);

        items.map((item) => {
            if (container.getAttribute('data-svg-toggle') === 'hover') {
                on('mouseenter', function () {
                    let svgTargetId = item.getAttribute('data-svg-id');
                    items.map((item) => removeClass('is-active', item));

                    findAllIn('.js-interactive-svg-toggle', container).map((toggle) => {
                        if (toggle.getAttribute('data-svg-id') !== svgTargetId) {
                            addClass('is-inactive', toggle);
                        }
                    });

                    addClass('is-active', item);
                }, item);

                on('mouseleave', function () {
                    items.map((item) => removeClass('is-active', item));
                    findAllIn('.js-interactive-svg-toggle', container).map((item) => removeClass('is-inactive', item));
                }, item);

            } else {
                on('click', function () {
                    let svgTargetId = item.getAttribute('data-svg-id');
                    let target = findIn('.js-interactive-svg-toggle[data-svg-id="'+ svgTargetId +'"]', container).getAttribute('id');

                    trigger('click', findIn('[data-toggle="collapse"][data-target="#'+ target +'"]', container));
                }, item);
            }
        });
    });

    onFind('.js-interactive-svg-toggle', function (element) {
        let container = closest('.js-interactive-svg-container', element);
        let target = findIn('.js-interactive-svg__item[data-svg-id="'+ element.getAttribute('data-svg-id') +'"]', container);

        if (container.getAttribute('data-svg-toggle') === 'hover') {
            on('mouseenter', function () {
                addClass('is-active', target)
            }, element);

            element.addEventListener("mouseleave", function() {
                removeClass('is-active', target)
            }, false);
        } else {
            on('show.bs.collapse', function () {
                addClass('is-active', target)
            }, element);

            on('hide.bs.collapse', function () {
                removeClass('is-active', target)
            }, element);
        }
    });
}